import { Font } from "components/shopFeatures/wizard/constants"
import { useEffect, useState } from "react"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import { setAllowSendingCodeAgain } from "../authSlice"

const StyledTimer = styled.div`
  margin-bottom: ${(p) => p.theme.spacing(2)}px;
  font-size: 1.125rem;

  font-family: ${Font.Heebo};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: center;
`

type CodeTimerProps = {
  className?: string
}

const CodeTimer = ({ className }: CodeTimerProps) => {
  const [secondsLeft, setSecondsLeft] = useState(-1)

  const { codeExpirationInSeconds } = useTypedSelector((state) => state.auth)

  const dispatch = useAppDispatch()

  // Update the seconds left when the code expiration changes (i.e when a new
  // code was sent)
  useEffect(() => {
    if (codeExpirationInSeconds) setSecondsLeft(codeExpirationInSeconds)
  }, [codeExpirationInSeconds])

  useEffect(() => {
    // If there are no seconds left then the user should be able to request to
    // send the code again
    if (secondsLeft === 0) {
      dispatch(setAllowSendingCodeAgain())
      return
    }

    const timeout = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000)

    return () => clearTimeout(timeout)
  }, [secondsLeft, dispatch])

  const minutes = `${Math.floor(secondsLeft / 60)}`.padStart(2, "0")
  const seconds = `${secondsLeft % 60}`.padStart(2, "0")

  return (
    <StyledTimer className={className}>
      {minutes}:{seconds}
    </StyledTimer>
  )
}

export default CodeTimer
